export default "/048cb1f2b29308e18768c65cfd51e426596a830c/14ed8dc335eec8ccd043173219a4387f.svg";